import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetTherapySequenceSiblings(patientProtocolId: string | undefined, excludeId: string | undefined) {
  return useQuery(
    queries.patients.getTherapySequenceSiblings({
      patientProtocolId: patientProtocolId || '',
      excludeId: excludeId || '',
    }),
    {enabled: Boolean(patientProtocolId && excludeId)}
  )
}
